export default "__VITE_ASSET__CPbY6aVc__"